<template>
  <div>

    <div>
      <div class="title">{{ datas.tag }}
        <!-- 时间筛选 -->
        <div class="time">
          <el-select v-model="datas.months" placeholder="请选择" size="mini" style="width: 160px;" @change="changeSelect">
            <el-option v-for="item in datas.data" :key="item.k" :label="item.k" :value="item.k">
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- 图表 -->
      <div class="echarts" v-if="datas.show">
        <echarts :option="datas.pieOption" />
      </div>
    </div>
  </div>
</template>
<script>
import { pieOption } from '@/utlis/echartsOption'
export default {
  props: {
    datas: { type: Object },

  },
  data() {
    return {
      show: true,
      pieOption,
      japanUserRoleInfo: JSON.parse(localStorage.getItem('japanUserRoleInfo'))

    };
  },
  created() {

  },
  mounted() {
    this.datas.show = false
    this.$nextTick(() => {
      this.setPieEcharts()
    }, 1000);
  },
  methods: {

    //切换日期格式
    changeSelect(e) {
      console.log(e);
      this.datas.months = e
      this.$forceUpdate()
      // 隐藏重新加载图标
      this.datas.show = false
      this.$nextTick(() => {
        this.setPieEcharts()
      }, 1000);
    },
    // 饼图
    setPieEcharts() {

      this.datas.pieOption = JSON.parse(JSON.stringify(this.pieOption)) // 复制模板
      this.datas.pieOption.legend = {
        orient: 'vertical',
        right: 10,
        bottom: 10,
        data: [],
        icon: 'circle',
      }
      this.datas.pieOption.tooltip.formatter = '{a} <br/>{b}: {c} ({d}%)'
      this.datas.pieOption.series = [
        {
          name: '赔款比例',
          type: 'pie',
          radius: ['50%', '85%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: true,
              color: '#4c4a4a',
            },
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '30',
              fontWeight: 'bold'
            },
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          labelLine: {
            show: true
          },
          data: []
        }
      ]
      this.datas.data.forEach((item, i) => {
        if (this.datas.months == item.k) {
          if (this.japanUserRoleInfo.id == 104) {
            item.rageList.forEach(items => {
              this.datas.pieOption.series[0].data.push({ value: items.reparationAmount, name: items.departName },)
              this.datas.pieOption.legend.data.push(items.departName)
            })
          } else {
            this.datas.pieOption.legend.data = ['业绩总额', '赔款金额']
            this.datas.pieOption.series[0].data = [
              { value: item.rageList.reparationAmount, name: '赔款金额' },
              { value: item.rageList.goodsAmount, name: '业绩总额' },
            ]
          }


        }
      })
      this.datas.show = true
    },

  }
}
</script>

<style lang='scss' scoped>
.echarts {
  width: 96%;
}


.title {
  display: flex;
  justify-content: space-between;
}
</style>